<template>
  <div>
    <el-form ref="questionaireRuleForm" :model="formData" :show-message="true" :inline-message="true">
      <el-scrollbar class="question-form-scrollbar">
        <div v-for="(question, questionIndex) in questionContentConstruction" :key="questionIndex">
          <el-form-item :label="question.title" :rules="question.requirement ? rule : null" :prop="questionIndex + '_' + question.title">
            <el-input v-if="question.questionType === 'text'" class="questionaire-form-item" v-model="formData[questionIndex + '_' + question.title]" size="small"></el-input>
            <el-radio-group v-if="question.questionType === 'radio'" class="questionaire-form-item" v-model="formData[questionIndex + '_' + question.title]">
              <el-radio v-for="(questionOption, questionOptionIndex) in question.options.split('\n')" :key="questionOptionIndex" :label="questionOptionIndex">
                {{ questionOption }}
              </el-radio>
            </el-radio-group>
            <el-checkbox-group v-if="question.questionType === 'checkbox'" class="questionaire-form-item" v-model="formData[questionIndex + '_' + question.title]">
              <el-checkbox v-for="(questionOption, questionOptionIndex) in question.options.split('\n')" :key="questionOptionIndex" :label="questionOptionIndex">{{ questionOption }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </div>
      </el-scrollbar>
    </el-form>
    <div class="questionaire-form-dialog-footer">
      <div class="questionaire-form-dialog-footer-button cancel" @click="close">{{ language === 1 ? 'Cancel' : '取消' }}</div>
      <div class="questionaire-form-dialog-footer-button confirm" :class="{ disabled: currentEditHeader !== 'catalog' }" @click="questionaireFormConfirm">
        {{ language === 1 ? 'Submit' : '提交问卷' }}
      </div>
    </div>
  </div>
</template>
<script>
import { submitForm } from '@api/questionaire'
export default {
  data() {
    return {
      questionaireRules: [],
      formData: {},
      rule: { required: true, message: '请填写必填内容', trigger: 'blur' }
    }
  },
  props: {
    type: {
      type: String,
      default: 'book'
    }
  },
  computed: {
    currentEditHeader() {
      return this.$store.state.edit.currentEditHeader
    },
    questionContent() {
      return this.$store.state.config[this.type + 'Obj'].questionContent
    },
    questionaireName() {
      return this.$store.state.config[this.type + 'Obj'].questionContent.formName
    },
    questionContentConstruction() {
      return this.$store.state.config[this.type + 'Obj'].questionContentConstruction
    },
    language() {
      return this.$store.state.config[this.type + 'Obj'].language
    }
  },
  watch: {
    questionContentConstruction: {
      handler(newVal) {
        if (newVal.length > 0) {
          let result = {}
          this.questionContentConstruction.forEach((item, index) => {
            result[index + '_' + item.title] = item.questionType === 'checkbox' ? [] : ''
          })
          this.formData = result
        }
      },
      immediate: true
    }
  },
  methods: {
    questionaireFormConfirm() {
      if (this.currentEditHeader !== 'catalog') {
        return
      }
      this.$refs.questionaireRuleForm.validate((valid, data) => {
        if (valid) {
          this.submitData()
        } else {
          this.$alert('请填写必填内容', '提示', {
            confirmButtonText: '确定'
          })
        }
      })
    },
    submitData() {
      let param = {
        formId: this.questionContent.id,
        formName: this.questionaireName,
        sourceIden: this.questionContent.sourceIden
      }
      let formData = []
      this.questionContentConstruction.forEach((item, index) => {
        if (item.questionType === 'text') {
          formData.push({ title: item.title, value: this.formData[index + '_' + item.title] })
        } else if (item.questionType === 'radio') {
          formData.push({ title: item.title, value: item.options.split('\n')[this.formData[index + '_' + item.title]] })
        } else if (item.questionType === 'checkbox') {
          let checkboxData = []
          let options = item.options.split('\n')
          this.formData[index + '_' + item.title].forEach((checkboxItem) => {
            checkboxData.push(options[checkboxItem])
          })
          formData.push({ title: item.title, value: checkboxData.join(',') })
        }
      })
      param.formData = JSON.stringify(formData)
      submitForm(param).then((res) => {
        if (res.status == 200) {
          this.close()
        } else {
          this.$alert(res.data.msg, '提示', {
            confirmButtonText: '确定'
          })
        }
      })
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped></style>
